import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';

import { bibShape, libraryShape, shelfItemShape, userIdentityShape } from '@bibliocommons/bc-prop-types';

import { getDigitalAvailability, openAvailability } from 'app/actions/AvailabilityDetailActions';
import { startGroupSearchFeedback } from 'app/actions/GroupSearchFeedbackActions';
import { getItemTransactionButtonType, TRANSACTION_BUTTON_TYPE } from 'app/helpers/bib/bibHelpers';
import { selectActiveHoldsByMetadataId } from 'app/selectors/HoldsSelector';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectCurrentSiteScopes } from 'app/selectors/ScopeSelector';
import { selectShelvesForCurrentUser } from 'app/selectors/ShelfSelector';
import { selectCurrentLibrary } from 'app/selectors/LibrarySelector';
import { selectCheckoutsByMetadataId } from 'app/selectors/CheckoutSelector';
import { catalogSearchOptionsShape } from 'app/shapes/search';
import ManifestationListItem from './ManifestationListItem';

export class ManifestationListItemContainer extends React.PureComponent {
  render() {
    const {
      hold,
      checkout,
      shelfItem,
      catalogSearchOptions,
      currentUser,
      item,
      itemPosition,
      itemPositionGrouped,
      totalCount,
      drawerOpen,
      library,
      getDigitalAvailability: dispatchGetDigitalAvailability,
      openAvailability: dispatchOpenAvailability,
      showGroupingDebug,
      searchScopeIsCurrent,
      showHoldCount,
      reciprocalRank,
      startGroupSearchFeedback: dispatchStartGroupFeedback
    } = this.props;

    const transactionButtonType = getItemTransactionButtonType({
      bib: item?.toJS(),
      checkout: checkout?.toJS(),
      hold: hold?.toJS()
    });

    const isEditable =
      Boolean(shelfItem) ||
      transactionButtonType === TRANSACTION_BUTTON_TYPE.CANCEL_HOLD ||
      transactionButtonType === TRANSACTION_BUTTON_TYPE.DIGITAL_OPTIONS;

    return (
      <ManifestationListItem
        catalogSearchOptions={catalogSearchOptions}
        currentUser={currentUser}
        item={item}
        itemPosition={itemPosition}
        itemPositionGrouped={itemPositionGrouped}
        totalCount={totalCount}
        drawerOpen={drawerOpen}
        editable={isEditable}
        library={library}
        getDigitalAvailability={dispatchGetDigitalAvailability}
        openAvailability={dispatchOpenAvailability}
        showGroupingDebug={showGroupingDebug}
        searchScopeIsCurrent={searchScopeIsCurrent}
        showHoldCount={showHoldCount}
        reciprocalRank={reciprocalRank}
        startGroupSearchFeedback={dispatchStartGroupFeedback}
      />
    );
  }
}

ManifestationListItemContainer.propTypes = {
  item: bibShape.isRequired,
  itemPosition: PropTypes.number,
  itemPositionGrouped: PropTypes.number,
  totalCount: PropTypes.number,
  shelfItem: shelfItemShape,
  catalogSearchOptions: catalogSearchOptionsShape.isRequired,
  currentUser: userIdentityShape,
  drawerOpen: PropTypes.bool,
  checkout: ImmutablePropTypes.mapContains({
    id: PropTypes.string
  }),
  getDigitalAvailability: PropTypes.func.isRequired,
  hold: ImmutablePropTypes.mapContains({
    id: PropTypes.string,
    status: PropTypes.string
  }),
  openAvailability: PropTypes.func.isRequired,
  searchScopeIsCurrent: PropTypes.bool,
  showHoldCount: PropTypes.bool,
  reciprocalRank: PropTypes.number,
  showGroupingDebug: PropTypes.bool,
  startGroupSearchFeedback: PropTypes.func.isRequired,
  library: libraryShape
};

ManifestationListItemContainer.displayName = 'ManifestationListItemContainer';

const mapStateToProps = (state, ownProps) => {
  const library = selectCurrentLibrary(state);
  const itemId = ownProps.item.get('id');
  const currentUser = selectCurrentUser(state);
  const shelfItem = selectShelvesForCurrentUser(state).get(itemId);
  const holds = selectActiveHoldsByMetadataId(state).get(itemId, Immutable.List());
  const checkouts = selectCheckoutsByMetadataId(state).get(itemId, Immutable.List());
  const currentScopeId = selectCurrentSiteScopes(state)
    .last()
    .get('scopeId');
  const searchScopeIsCurrent = state.getIn(['search', 'catalogSearch', 'scope']) === currentScopeId;
  const showHoldCount = library.get('showHoldCountInSearch');

  return {
    library,
    shelfItem,
    hold: holds.size === 1 ? holds.first() : null,
    checkout: checkouts.first(),
    catalogSearchOptions: state.getIn(['search', 'catalogSearchOptions']),
    currentUser,
    showGroupingDebug:
      currentUser &&
      currentUser.get('showGroupingDebug') &&
      state.getIn(['search', 'catalogSearch', 'view']) === 'grouped',
    searchScopeIsCurrent,
    showHoldCount
  };
};

const mapDispatchToProps = {
  getDigitalAvailability,
  openAvailability,
  startGroupSearchFeedback
};

export default connect(mapStateToProps, mapDispatchToProps)(ManifestationListItemContainer);
